import React, { useEffect, useState } from 'react';
import { Box, Stack } from '@mui/material';

import 'react-image-crop/dist/ReactCrop.css';
import { IconWrapper } from 'components/Icon';
import { ImageUpload } from 'components/ImageUpload';
import { useParams } from 'react-router-dom';
import { useImageUpload } from '../api/uploadImage';
import { useGetCompanyById } from '../api/getCompanyById';

const baseStyles = {
  width: 100,
  innerHeight: 1,
  borderRadius: 1,
  // overflow: 'hidden',
};
const imageWrapperStyles = {
  bottom: 0,
  height: 100,
  position: 'absolute',
  cursor: 'pointer',

  ...baseStyles,
};

const placeholderStyles = {
  ...baseStyles,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
};

export const SquareImage = ({ sx = {}, wrapperSx = {}, image, bannerChangable = true, companyId: companyIdProp = null }) => {
  const { id: idParam } = useParams();
  const companyId = companyIdProp || idParam;
  const [open, setOpen] = useState(false);

  const { refetch } = useGetCompanyById(companyId);

  const { mutate: uploadImage } = useImageUpload(companyId, 'square_logo', refetch);

  return (
    <>
      <ImageUpload
        title="Upload logo image"
        uploadImage={uploadImage}
        image={image}
        open={open}
        handleClose={() => setOpen(false)}
        modalSx={{ width: 440 }}
        cropHeight={440}
      />

      <Box
        ml={{xs: 2, md: 4}}
        width={{xs: 75, md: 100}}
        onClick={() => {
          if (bannerChangable) setOpen(true);
        }}
        sx={{
          position: 'relative',
          innerHeight: 1,
          borderRadius: 1,
          cursor: bannerChangable ? 'pointer' : 'default',
          ...wrapperSx
        }}
      >
        <Stack
          position="absolute"
          width={1}
          bottom={24}
          height={{xs: 75, md: 100}}
          justifyContent="center"
          alignItems="center"
          borderRadius={1}
          overflow="hidden"
          sx={{ border: '1px solid', borderColor: 'grey.200', bgcolor: 'background.paper', ...sx }}
        >
          {!image && (
            <IconWrapper
              icon="photo"
              sx={{ svg: { width: 40, height: 40, mt: -1, stroke: 'grey.300', color: 'grey.300' } }}
            />
          )}

          {image && (
            <Box width={{xs: 75, md: 100}} height={{xs: 75, md: 100}} sx={{ img: { width: 1, height: 1 }, ...sx }}>
              <img src={image} alt="company" />
            </Box>
          )}
        </Stack>
      </Box>
    </>
  );
};
